import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Clock20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_793)'>
      <path
        d='M10.75 9.68934V4H9.25V10.3107L12.9697 14.0303L14.0303 12.9697L10.75 9.68934Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 0.25C4.61522 0.25 0.25 4.61522 0.25 10C0.25 15.3848 4.61522 19.75 10 19.75C15.3848 19.75 19.75 15.3848 19.75 10C19.75 4.61522 15.3848 0.25 10 0.25ZM1.75 10C1.75 5.44365 5.44365 1.75 10 1.75C14.5563 1.75 18.25 5.44365 18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C5.44365 18.25 1.75 14.5563 1.75 10Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_793'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Clock20.displayName = 'Clock20';
export default Clock20;
